import { CommentsPanel as SharedCommentsPanel } from "@vojomo-core/shared/src/components/collab/comments/CommentsPanel";
import { useTopic } from "pages/TopicViewer/hooks/use-topics";

interface CommentsPanelProps {
  commentsOpen: boolean;
  setCommentsOpen: (open: boolean) => void;
}

// Topics-specific adapter: supplies the shared collaborative CommentsPanel with
// the topic's persisted comments / streaming / write-access from useTopic(), so
// the shared component stays decoupled from the TopicViewer context.
export const CommentsPanel = ({
  commentsOpen,
  setCommentsOpen
}: CommentsPanelProps) => {
  const { output, isStreaming } = useTopic();

  return (
    <SharedCommentsPanel
      commentsOpen={commentsOpen}
      setCommentsOpen={setCommentsOpen}
      comments={output?.comments}
      isStreaming={isStreaming}
      // Topics never gated comment authoring on hasWriteAccess in the panel
      // (the editor selection button is the real gate). Keep the original
      // behavior exactly: the comment UI is always interactive here.
      canComment={true}
    />
  );
};
